// GENERATED FILE - DO NOT MODIFY

export enum BookingApprovalStatusDto {
    NotRequired = "NotRequired",
    WaitingForApproval = "WaitingForApproval",
    Approved = "Approved",
    Refused = "Refused",
}